module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mailchimp/subscriber/subscriber-create/subscriber-create.component.scss
// module id = ./src/app/mailchimp/subscriber/subscriber-create/subscriber-create.component.scss
// module chunks = main